/*import { OverlayScrollbars } from 'overlayscrollbars';

if (document.querySelector('[data-scroll]')) {
  const scrollElArr = document.querySelectorAll('[data-scroll]');
  scrollElArr.forEach((scrollEl) => {
    const osInstance = OverlayScrollbars(scrollEl, {});
  });
}*/

import Scrollbar from 'smooth-scrollbar';

window.scrollInitFunc = function scrollInitFunc() {
  if (document.querySelector('[data-scroll]')) {
    const scrollElArr = document.querySelectorAll('[data-scroll]');
    scrollElArr.forEach((el) => {
      if (!el.classList.contains('is-scroll-init')) {
        el.classList.add('is-scroll-init');

        const startScrollWidth = parseInt(
          el.getAttribute('data-start-scroll'),
          10
        );

        if (!startScrollWidth || window.innerWidth <= startScrollWidth) {
          const scrollbar = Scrollbar.init(el, {
            alwaysShowTracks: true,
            damping: 0.1,
            renderByPixels: true,
          });

          scrollbar.addListener(({ offset }) => {
            if (offset.x !== 0) {
              scrollbar.setPosition(0, offset.y);
            }
          });
        }
      }
    });
  }
};

scrollInitFunc();
